import './text-input-group.css';
export default {
  "button": "pf-v5-c-button",
  "chipGroupMain": "pf-v5-c-chip-group__main",
  "modifiers": {
    "disabled": "pf-m-disabled",
    "plain": "pf-m-plain",
    "icon": "pf-m-icon",
    "hint": "pf-m-hint"
  },
  "textInputGroup": "pf-v5-c-text-input-group",
  "textInputGroupGroup": "pf-v5-c-text-input-group__group",
  "textInputGroupIcon": "pf-v5-c-text-input-group__icon",
  "textInputGroupMain": "pf-v5-c-text-input-group__main",
  "textInputGroupText": "pf-v5-c-text-input-group__text",
  "textInputGroupTextInput": "pf-v5-c-text-input-group__text-input",
  "textInputGroupUtilities": "pf-v5-c-text-input-group__utilities",
  "themeDark": "pf-v5-theme-dark"
};